import { TeamsKitApp } from '@britania/teams-kit-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { appConfig } from '#src/app.config';

const root = document.getElementById('root');
if (root === null) {
  throw new Error('index.html sem o elemento #root');
}

createRoot(root).render(
  <StrictMode>
    <TeamsKitApp config={appConfig} />
  </StrictMode>,
);
